import React from 'react';
import axios from 'axios';

class CV extends React.Component {
  apiEndpoint = 'https://lrfiosxbs6.execute-api.ap-northeast-2.amazonaws.com';
  state = {
    content: '',
    isLoading: true
  }

  componentDidMount() {
    axios.get(`${this.apiEndpoint}/default/content`, {
      params: {
        content_type: 'R'
      }
    }).then((response) => {
      this.setState({
        content: this.extractContentText(response.data),
        isLoading: false
      });
    }).catch((error) => {
      console.error(error);
      this.setState({ isLoading: false });
    });
  }

  extractContentText = (data) => {
    if (typeof data === 'string') {
      return data;
    }

    if (data && typeof data.content === 'string') {
      return data.content;
    }

    if (data && typeof data.results === 'string') {
      return data.results;
    }

    if (data && Array.isArray(data.results) && data.results.length > 0) {
      const firstResult = data.results[0];

      if (typeof firstResult === 'string') {
        return firstResult;
      }

      if (firstResult && typeof firstResult.content === 'string') {
        return firstResult.content;
      }
    }

    return '';
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div className="public-content-loading">
          <div className="public-content-spinner" />
        </div>
      );
    }

    return (
      <>
        <div className="">
          <div className="" dangerouslySetInnerHTML={{__html: this.state.content}}>
          </div>
        </div>
      </>
    );
  }
}

export default CV;
